<app-menu>
    <button mat-raised-button color="primary" [routerLink]="'/consolidator'">Consolidator</button>
    <button mat-raised-button color="primary" (click)="clearFilter()">Clear Filters</button>
    <ag-grid-angular *ngIf="gridReady" style="width: 100%; height: 100%;" [columnDefs]="columnDefs"
        [detailCellRenderer]="detailCellRenderer" [detailCellRendererParams]="detailCellRendererParams" [detailRowHeight]="500" [masterDetail]="true"
        [defaultColDef]="defaultColDef" [autoGroupColumnDef]="autoGroupColumnDef"
        [rowGroupPanelShow]="rowGroupPanelShow" [rowData]="manifests" [class]="themeClass"
        (gridReady)="onGridReady($event)" [initialState]="initialState" (stateUpdated)="onStateUpdated($event)">

    </ag-grid-angular>

</app-menu>
